import { withStyles } from "@material-ui/core";
//theme is not supported in gantt chart hence not using theme object for styling.
const styles = {
  rowContainer: {
    display: "flex",
    flexDirection: "column",
    minWidth: 82,
    marginBottom: 4,
  },
  label: {
    fontWeight: 600,
    fontSize: 10,
    marginBottom: -8,
    color: "#666666",
  },
  value: {
    fontWeight: 700,
    fontSize: 12,
    textTransform: "uppercase",
    color: "#444444",
    lineHeight: 1,
    marginTop: 5,
    maxWidth: 60,
  },
  statusCodeValue: {
    wordWrap: "break-word",
    color: "#FA5C64",
  },
};
const PopupFieldRenderer = ({
  label,
  value,
  rowClassName,
  labelClassName,
  valueClassName,
  statusCodeValue,
  classes,
}) => {
  return (
    <div
      className={`${classes.rowContainer} ${rowClassName ? rowClassName : ""}`}
    >
      <span
        className={`${classes.label} ${labelClassName ? labelClassName : ""}`}
      >
        {label}
      </span>
      <span
        className={`${classes.value} ${valueClassName ? valueClassName : ""}`}
      >
        {value}
        {statusCodeValue && (
          <span className={classes.statusCodeValue}> ({statusCodeValue})</span>
        )}
      </span>
    </div>
  );
};

export default withStyles(styles)(PopupFieldRenderer);
